import React, { useCallback } from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { action_fetch_points_history_expired } from "../../../../../../store/actions/pages/customer";
import { useSelector } from "react-redux";
import PointsHistoryList from "../components/list/index"
import { useStore } from "react-redux";
import { useParams } from "react-router-dom";
import { useQuery } from "../../../../../hooks/common";

const PointsHistoryExpired = props =>{
    const dispatch = useDispatch();
    const pageCustomer = useSelector(state=>state.pageCustomer);
    const { pointsHistoryExpired } = pageCustomer;
    const store = useStore()
    const params = useParams()
    const query = useQuery()

    useEffect(async () =>{
        if(window.__INITIAL_STATE__){
            delete window.__INITIAL_STATE__;
        }else{
            await PointsHistoryExpired.fetchData(store, params, query)
        }
    }, []);

    const loadHandle = useCallback(() =>{
        dispatch(action_fetch_points_history_expired());
    }, []);

    return <PointsHistoryList 
        list={pointsHistoryExpired?.data}
        request={loadHandle}
        loading={pointsHistoryExpired?.loading}
        finished={pointsHistoryExpired?.finished}
        isExpired
    />
}

PointsHistoryExpired.fetchData = async (store, params, search, headers) => {
    await store.dispatch(action_fetch_points_history_expired(headers))
}

export default PointsHistoryExpired